import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import search from '@/pages/search'



//热门活动
import Popularactivities from '@/pages/Popularactivities/popularactivities'
//热门活动 详情
import popdetais from '@/pages/Popularactivities/popdetais'
//毕业去向
import Graduation from '@/pages/Graduation/graduation'
//留学资讯
import Overseas from '@/pages/Overseas/overseas'
//所有服务
import Allservices from '@/pages/Allservices/allservices'
// 院校指南
import school from '@/pages/school/schoolList'
// 院校详情
import schoolDetail from '@/pages/school/schoolDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/Popularactivities',
      name: 'Popularactivities',
      component: Popularactivities
    },
    //热门活动
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/popdetais',
      name: 'popdetais',
      component: popdetais
    },
    //毕业去向
    {
      path: '/Graduation',
      name: 'Graduation',
      component: Graduation
    },
    //留学资讯
    {
      path: '/Overseas',
      name: 'Overseas',
      component: Overseas
    },
    //所有服务
    {
      path: '/Allservices',
      name: 'Allservices',
      component: Allservices
    },
    // 院校指南
    {
      path: '/school',
      name: 'school',
      component: school
    },
    // 院校详情
    {
      path: '/schoolDetail',
      name: 'schoolDetail',
      component: schoolDetail
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js